export default [
  {
    path: "/permohonan-beasiswa",
    component: () => import("@/pages/permohonan-beasiswa/list-page.vue"),
    meta: {
      requiredLevel: ["admin", "verificator"],
    },
  },
  {
    path: "/permohonan-beasiswa/verifikasi/:id",
    component: () => import("@/pages/permohonan-beasiswa/verifikasi-page.vue"),
    meta: {
      requiredLevel: ["admin", "verificator"],
    },
  },
  {
    path: "/pengajuan-beasiswa",
    component: () => import("@/pages/pengajuan-beasiswa/pengajuan-page.vue"),
    meta: {
      requiredLevel: ["user"],
    },
  },
  {
    path: "/pengajuan-beasiswa/detail/:id",
    component: () => import("@/pages/pengajuan-beasiswa/pengajuan-detail.vue"),
    meta: {
      requiredLevel: ["user"],
    },
  },
  {
    path: "/pengajuan-beasiswa/pemberkasan/:id",
    component: () => import("@/pages/pengajuan-beasiswa/pemberkasan-page.vue"),
    meta: {
      requiredLevel: ["user"],
    },
  },
  {
    path: "/pengajuan-beasiswa/upload-buku-rekening/:id",
    component: () => import("@/pages/pengajuan-beasiswa/upload-rekening.vue"),
    meta: {
      requiredLevel: ["user"],
    },
  },
];
